'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
const initialState = ImmutableMap();
export default ((state = initialState, action) => {
  const {
    type,
    meta = {},
    payload = {}
  } = action;
  const {
    responseJSON
  } = meta;
  let errorType;
  let errorTokens;

  switch (type) {
    case Actions.ADWORDS_AD_CREATE_FAILED:
      {
        // Problem(s) with a single ad are wrapped in a list, so as to be compatible
        // with campaign creation where multiple ads are created.
        // We should probably update the backend to handle both cases more elegantly,
        // but this is fine for a first pass.
        const adCreationFailure = responseJSON.errors[0];
        errorType = adCreationFailure.errorType; // Errors may be local to a particular area of the code; if not, simply use the message.

        errorTokens = adCreationFailure.errorTokens || {
          errorType: adCreationFailure.message
        };
        state = state.set(errorType, ImmutableMap(errorTokens));
        break;
      }

    case Actions.DISMISS_ERROR:
      state = state.delete(payload.errorType);
      break;

    default:
      break;
  }

  return state;
});